import { NavLink } from 'react-router-dom';
import type { TipoUsuario } from '../contexts/AuthContext';
import './Sidebar.css';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

interface NavSection {
  label: string;
  icon: string;
  items: NavItem[];
}

type SidebarEntry = NavItem | NavSection;

function isSection(entry: SidebarEntry): entry is NavSection {
  return 'items' in entry;
}

function getNavItems(tipo: TipoUsuario): SidebarEntry[] {
  switch (tipo) {
    case 'Assistente':
      return [
        {
          label: 'Empreendimentos',
          icon: '🏗️',
          items: [
            { path: '/admin/empreendimentos?tipo=obra', label: 'Obras', icon: '' },
            { path: '/admin/empreendimentos?tipo=projeto', label: 'Projetos', icon: '' },
          ],
        },
      ];
    case 'Cliente':
      return [
        { path: '/empreendimentos', label: 'Meus Projetos', icon: '🏠' },
        { path: '/notificacoes', label: 'Notificações', icon: '🔔' },
      ];
    case 'Arquiteto':
      return [
        { path: '/painel', label: 'Dashboard', icon: '📊' },
        { path: '/painel/usuarios', label: 'Usuários', icon: '👥' },
        { path: '/painel/tipos-etapa', label: 'Tipos de Etapa', icon: '📋' },
      ];
    case 'Master':
      return [
        { path: '/admin/conteudo', label: 'Conteúdo do Site', icon: '📝' },
        { path: '/painel', label: 'Painel Gerencial', icon: '📊' },
        {
          label: 'Empreendimentos',
          icon: '🏗️',
          items: [
            { path: '/admin/empreendimentos?tipo=obra', label: 'Obras', icon: '' },
            { path: '/admin/empreendimentos?tipo=projeto', label: 'Projetos', icon: '' },
          ],
        },
        { path: '/admin/usuarios', label: 'Usuários', icon: '👥' },
        { path: '/admin/tipos-etapa', label: 'Tipos de Etapa', icon: '📋' },
      ];
  }
}

interface SidebarProps {
  userType: TipoUsuario;
  temSenhaLocal?: boolean;
  isOpen: boolean;
  onClose: () => void;
}

export default function Sidebar({ userType, temSenhaLocal, isOpen, onClose }: SidebarProps) {
  const entries = getNavItems(userType);

  return (
    <>
      <div
        className={`sidebar-overlay${isOpen ? ' sidebar-overlay--visible' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <aside className={`sidebar${isOpen ? ' sidebar--open' : ''}`} aria-label="Menu de navegação">
        <nav className="sidebar__nav">
          {entries.map((entry) => {
            if (isSection(entry)) {
              return (
                <div key={entry.label}>
                  <div className="sidebar__section-title">
                    <span className="sidebar__section-title-icon" aria-hidden="true">
                      {entry.icon}
                    </span>
                    {entry.label}
                  </div>
                  <div className="sidebar__submenu">
                    {entry.items.map((item) => (
                      <NavLink
                        key={item.path}
                        to={item.path}
                        end
                        className={({ isActive }) =>
                          `sidebar__link${isActive ? ' sidebar__link--active' : ''}`
                        }
                        onClick={onClose}
                      >
                        {item.icon && (
                          <span className="sidebar__link-icon" aria-hidden="true">
                            {item.icon}
                          </span>
                        )}
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
              );
            }

            return (
              <NavLink
                key={entry.path}
                to={entry.path}
                end
                className={({ isActive }) =>
                  `sidebar__link${isActive ? ' sidebar__link--active' : ''}`
                }
                onClick={onClose}
              >
                <span className="sidebar__link-icon" aria-hidden="true">
                  {entry.icon}
                </span>
                {entry.label}
              </NavLink>
            );
          })}

          {/* Alterar Senha — visível apenas para usuários com login local */}
          {temSenhaLocal && (
            <NavLink
              to="/alterar-senha"
              end
              className={({ isActive }) =>
                `sidebar__link${isActive ? ' sidebar__link--active' : ''}`
              }
              onClick={onClose}
            >
              <span className="sidebar__link-icon" aria-hidden="true">
                🔑
              </span>
              Alterar Senha
            </NavLink>
          )}
        </nav>
      </aside>
    </>
  );
}
